var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-page"},[_c('div',{staticClass:"report-image",domProps:{"innerHTML":_vm._s(_vm.htmlData[_vm.index])}}),_c('div',{staticClass:"report-view-full"},[_c('router-link',{attrs:{"target":"_blank","to":"/contact"}},[_c('div',{staticClass:"button"},[_vm._v("查看完整报告")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }